import { useQueryClient } from '@tanstack/react-query'

import { invoiceDetailKey, INVOICES_KEY } from './keys'

/** shared invalidation after any status transition: the list, the stat cards,
 *  and the affected detail view all read stale data otherwise. */
export function useInvalidateInvoices() {
  const queryClient = useQueryClient()
  return (id?: string) => {
    void queryClient.invalidateQueries({ queryKey: INVOICES_KEY })
    if (id) {
      void queryClient.invalidateQueries({ queryKey: invoiceDetailKey(id) })
    }
  }
}
